define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const mathAlgorithms = require('util/math.util').algorithms;
    const { disableBodyScroll, enableBodyScroll } = require('bundle');

    /**
     * @name ScrollManager
     */
    var ScrollManager = {

        /**
         * Scrolls viewport to specified Y position.
         * @type {Function}
         * @public
         *
         * @param  {number} YAxisPosition
         * @param  {number} [duration]
         * @param  {Function} [easingFunction]
         * @param  {Function} [callback]
         */
        scrollTo: function(YAxisPosition, duration, easingFunction, callback) {
            easingFunction = easingFunction || mathAlgorithms.linear;

            var start = Date.now();
            var scrolledElement = this._getScrollEl();
            var fromPosition = scrolledElement.scrollTop;

            // do not call `requestAnimationFrame`
            if (!duration) {
                scrolledElement.scrollTop = YAxisPosition;
                callback && callback();
                return;
            }

            if (fromPosition === YAxisPosition) {
                callback && callback();
                return;
            }

            function scroll() {
                var currentTime = Date.now();
                var timeLeft = Math.min(1, (currentTime - start) / duration);

                scrolledElement.scrollTop = easingFunction(timeLeft) * (YAxisPosition - fromPosition) + fromPosition;

                if (timeLeft < 1) {
                    window.requestAnimationFrame(scroll);
                } else {
                    callback && callback();
                }
            }

            window.requestAnimationFrame(scroll);
        },

        _getScrollEl: function() {
            return document.scrollingElement || document.documentElement;
        },

        /**
         * Prevents other elements from scrolling
         * Each lock should always be followed with corresponding unlock or you'll be unable to unlock scroll.
         * @param {*} lockOwner - Any arbitrary defined value used as a token to identify scroll lock owner in
         * locking/unlocking procedures. Use separate values for lockOwner to avoid accidental scroll unlocking.
         * @param {Object} [options]
         * @param {boolean=true} [options.reserveScrollBarGap] - Replace scrollbar gap with padding to avoid flicker
         * @public
         */
        disableScrolling: disableBodyScroll,

        /**
         * Unlocks scrolling
         * Scrolling will be unlocked only when all locks are released
         * If you somehow lose any of tokens scroll will be locked permanently
         * @param {*} lockOwner
         * @public
         */
        enableScrolling: enableBodyScroll,

        //TODO remove ASAP (when chrome will fix this bug)
        enableIos10ChromeFocusFix: function() {
            document.querySelector('.fn-page').addEventListener('focus', this.addHeight, true);
            document.querySelector('.fn-page').addEventListener('blur', this.resetHeight, true);
        },

        disableIos10ChromeFocusFix: function() {
            document.querySelector('.fn-page').removeEventListener('focus', this.addHeight, true);
            document.querySelector('.fn-page').removeEventListener('blur', this.resetHeight, true);
        },

        addHeight: function(e) {
            var isInputCanBeFocused = ['INPUT', 'SELECT'].includes(e.target.tagName);
            var isCheckbox = e.target.type === 'checkbox';

            if (isInputCanBeFocused && !isCheckbox) {
                var pageHeight = parseInt(window.getComputedStyle(document.body).height) * 1.3;
                var isLandscapeOrientation = window.orientation === 90 || window.orientation === -90;
                var baseYPosition = window.innerHeight / (!isLandscapeOrientation ? 4 : 6) + window.scrollY;
                var elementTop = e.target.getBoundingClientRect().top + window.scrollY;
                var elementHeight = parseFloat(getComputedStyle(e.target).height);
                var offset = elementTop - baseYPosition;
                var yPosition = window.scrollY + offset + elementHeight / 2;

                $('body').css('height', pageHeight + 'px');

                ScrollManager.scrollTo(
                    yPosition,
                    500,
                    function(t) {
                        return 1 + --t * Math.pow(t, 4); //easeOutQuint
                    }
                );
            }
        },

        resetHeight: function() {
            $('body').css('height', '');
        }

    };

    module.exports = ScrollManager;
});
